import {
    Button,
    Col,
    Divider,
    Grid,
    Heading,
    Message,
    Row,
    Stack,
    toaster,
} from "rsuite";
import * as React from "react";

import { v4 as uuidv4 } from "uuid";
import useAxiosPrivate from "app/hooks/useAxiosPrivate";
import { findDuplicateIds, hasInvalidIds, mergeArraysById } from "functions";
import { LoadingButton } from "@mui/lab";

import AgGrid from "app/components/AgGrid";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import SideDrawer from "app/components/SideDrawer";
import { Field, Formik } from "formik";
import { Autocomplete, TextField } from "@mui/material";
import { DateField, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import * as yup from "yup";
import useAPINew from "app/hooks/useAPINew";
import { Balance, PictureAsPdf } from "@mui/icons-material";
import pdfToText from 'react-pdftotext';

const validationSchema = yup.object({});
const columns1 = [
    { id: "ID", field: "ID", minWidth: 100 },
    { id: "ReceiptNo", field: "ReceiptNo", minWidth: 150 },
    {
        id: "Date",
        field: "Date",
        minWidth: 200,
        type: "date",
        filter: "agDateColumnFilter",
        filterParams: {
            // pass in additional parameters to the Date Filter
        },
        valueFormatter: (params) => {
            if (params.value && params.value !== "0000-00-00") {
                return moment(params.value, "YYYY-MM-DD").format("DD-MM-YYYY");
            }
            return params.value;
        },
    },
    {
        id: "NextDue", field: "NextDue", minWidth: 200, type: "date", filter: "agDateColumnFilter",
        valueFormatter: (params) => {
            if (params.value && params.value !== "0000-00-00") {
                return moment(params.value, "YYYY-MM-DD").format("DD-MM-YYYY");
            }
            return params.value;
        },
    },
    { id: "CashierName", field: "CashierName", minWidth: 200 },
    { id: "CashierId", field: "CashierId", minWidth: 150 },
    { id: "PolicyNo", field: "PolicyNo", minWidth: 200 },
    { id: "Name", field: "Name", minWidth: 200 },
    { id: "FullName", field: "FullName", minWidth: 200 },
    { id: "FatherName", field: "FatherName", minWidth: 200, headerName: "Father/Husband Name" },
    { id: "Vpo", field: "Vpo", minWidth: 200 },
    { id: "Tehsil", field: "Tehsil", minWidth: 200 },
    { id: "District", field: "District", minWidth: 200 },
    { id: "PinCode", field: "PinCode", minWidth: 200 },
    { id: "Mobile", field: "Mobile", minWidth: 200 },
    { id: "Revival", field: "Revival", minWidth: 100 },
    { id: "Plan", field: "Plan", minWidth: 100 },
    { id: "Term", field: "Term", minWidth: 100 },
    { id: "Mode", field: "Mode", minWidth: 150 },
    { id: "SumAssured", field: "SumAssured", minWidth: 150 },
    { id: "AgencyCode", field: "AgencyCode", minWidth: 150 },
    { id: "DOC", field: "FUP", minWidth: 200, headerName: "DOC" },
    { id: "ServiceBranch", field: "ServiceBranch", minWidth: 200 },
    { id: "PremiumAmount", field: "PremiumAmount", minWidth: 200 },
    { id: "Inst", field: "Inst", minWidth: 200 },
    { id: "DueFr", field: "DueFr", minWidth: 150 },
    { id: "DueTo", field: "DueTo", minWidth: 150 },
    { id: "CDACharges", field: "CDACharges", minWidth: 200 },
    { id: "XCharges", field: "XCharges", minWidth: 200 },
    { id: "CessAmt", field: "CessAmt", minWidth: 200 },
    { id: "LateFee", field: "LateFee", minWidth: 200 },
    { id: "LateFeeDiscount", field: "LateFeeDiscount", minWidth: 200 },
    { id: "GSTAmt", field: "GSTAmt", minWidth: 200 },
    { id: "TotAmtDR", field: "TotAmtDR", minWidth: 200 },
    { id: "Cash", field: "Cash", minWidth: 200 },
    { id: "Bank", field: "Bank", minWidth: 200 },
    { id: "Balance", field: "Balance", minWidth: 200 },
    { id: "PaymentBy", field: "PaymentBy", minWidth: 200 },
    { id: "Remark", field: "Remark", minWidth: 200 },
    { id: "UploadStatus", field: "UploadStatus", Width: 100 },
    { id: "Message", field: "Message", minWidth: 500 },
];

export default function ImportByPastePremiumPointNew() {
    const [data, setData] = React.useState([]);
    const [status, setStatus] = React.useState(false);
    const [pdfLoading, setPdfLoading] = React.useState(false);
    const [pdfProgress, setPdfProgress] = React.useState("");
    const pdfInputRef = React.useRef(null);
    const PaymentByList = useAPINew("GetPaymentByList.php");
    const CashierList = useAPINew("GetCashierList.php");
    const axiosPrivate = useAxiosPrivate();
    const [initialValues, setInitialValues] = React.useState({
        Name: null,
        FUP: null,
        ReceiptNo: "",
        CashierId: "",
        NextDue: null,
        FullName: "",
        FatherName: "",
        Vpo: "",
        Tehsil: "",
        District: "",
        PinCode: "",
        Mobile: "",
        Revival: "",
        Plan: "",
        Term: "",
        Mode: "",
        SumAssured: "",
        AgencyCode: "",
        DueFr: "",
        DueTo: "",

        Health: null,
    });
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [selectedRowData, setSelectedRowData] = React.useState([]);
    const [filteredRows, setFilteredRows] = React.useState([]);

    async function GetDataByID1(ID) {
        try {
            const oldData = data.filter((a) => {
                return a.UniqueID === ID;
            });
            // console.log(oldData);
            if (oldData.length > 0) {
                let parts = oldData[0].FUP.split("/");
                let formattedDateString = `${parts[2]}-${parts[1]}-${parts[0]}`;
                let customDateObject = new Date(formattedDateString);

                // For Date, it is already YYYY-MM-DD so we can parse it directly
                let customDateObject1 = new Date(oldData[0].Date);

                const newData = {
                    UniqueID: oldData[0]?.UniqueID,
                    ID: oldData[0]?.ID,
                    ReceiptNo: oldData[0]?.ReceiptNo,
                    CashierId: oldData[0]?.CashierId
                        ? { title: oldData[0]?.CashierId, value: oldData[0]?.CashierId }
                        : { title: "", value: "" },
                    NextDue: oldData[0]?.NextDue ? moment(oldData[0].NextDue, "YYYY-MM-DD").toDate() : null,
                    CashierName: oldData[0]?.CashierName || "",
                    FullName: oldData[0]?.FullName || "",
                    FatherName: oldData[0]?.FatherName || "",
                    Vpo: oldData[0]?.Vpo || "",
                    Tehsil: oldData[0]?.Tehsil || "",
                    District: oldData[0]?.District || "",
                    PinCode: oldData[0]?.PinCode || "",
                    Mobile: oldData[0]?.Mobile || "",
                    Revival: oldData[0]?.Revival || "",
                    Plan: oldData[0]?.Plan || "",
                    Term: oldData[0]?.Term || "",
                    Mode: oldData[0]?.Mode || "",
                    SumAssured: oldData[0]?.SumAssured || "",
                    AgencyCode: oldData[0]?.AgencyCode || "",
                    CDACharges: oldData[0]?.CDACharges,
                    CessAmt: oldData[0]?.CessAmt,
                    GSTAmt: oldData[0]?.GSTAmt,
                    Inst: oldData[0]?.Inst,
                    DueFr: oldData[0]?.DueFr || "",
                    DueTo: oldData[0]?.DueTo || "",
                    LateFee: oldData[0]?.LateFee,
                    LateFeeDiscount: oldData[0]?.LateFeeDiscount,
                    Name: oldData[0]?.Name,
                    PolicyNo: oldData[0]?.PolicyNo,
                    PremiumAmount: oldData[0]?.PremiumAmount,
                    ServiceBranch: oldData[0]?.ServiceBranch,
                    TotAmtDR: parseFloat(oldData[0]?.TotAmtDR.replace(",", "")),
                    XCharges: oldData[0]?.XCharges,
                    Cash: oldData[0]?.Cash,
                    Bank: oldData[0]?.Bank,
                    Balance: oldData[0]?.Balance,
                    Remark: oldData[0]?.Remark,
                    PaymentBy: oldData[0]?.PaymentBy
                        ? { value: oldData[0]?.PaymentBy, title: oldData[0]?.PaymentBy }
                        : { value: "", title: "" },

                    FUP:
                        oldData[0].FUP === "0000-00-00" || oldData[0].FUP === null
                            ? null
                            : customDateObject,
                    Date:
                        oldData[0].Date === "0000-00-00" || oldData[0].Date === null
                            ? null
                            : customDateObject1,
                };
                console.log(newData);
                setInitialValues(newData);
            }
        } catch (error) {
            // console.log(error);
            toaster.push(
                <Message type="error" bordered showIcon>
                    <strong>Error!</strong> Error occured
                </Message>
            );
        }
    }

    function updateDatainGrid(rawdata, ID) {
        const olddata = data.map((d) =>
            d.UniqueID === ID ? { ...d, ...rawdata } : d
        );
        setData(olddata);
    }
    React.useEffect(() => {
        let isSubscribed = true;
        if (isSubscribed)
            if (selectedRowData?.UniqueID) {
                GetDataByID1(selectedRowData.UniqueID);
            }
        return () => {
            isSubscribed = false;
        };
    }, [selectedRowData?.UniqueID, selectedRowData]);



    const handlePastePdf = async (event) => {
        event.preventDefault();
        const clipboardData = await window.navigator.clipboard.readText();
        console.log("PDF Paste Data:", clipboardData);

        const parsedData = parsePdfCopiedData(clipboardData);
        if (parsedData && parsedData.length > 0) {
            setData((prev) => [...prev, ...parsedData]);
            toaster.push(
                <Message type="success" bordered showIcon>
                    <strong>Success!</strong>{" "}
                    {`Parsed ${parsedData.length} record(s) from PDF text`}
                </Message>
            );
        } else {
            toaster.push(
                <Message type="warning" bordered showIcon>
                    <strong>Warning!</strong> Could not parse PDF text. Check console for raw data.
                </Message>
            );
            console.log("Raw pasted data:", clipboardData);
        }
    };


    const parsePdfCopiedData = (text) => {
        try {
            const lines = text.split("\n").map((l) => l.trim()).filter((l) => l !== "");
            const records = [];
            let receiptNo = "";
            let receiptNoMatch = text.match(/Receipt\s+Number\s*[:\-]?\s*(\S+)/i);
            if (receiptNoMatch) {
                receiptNo = receiptNoMatch[1].trim();
            }

            let cashierNameGlobal = "DIFS";
            let cashierIdGlobal = "";
            let globalDate = moment().format("YYYY-MM-DD");
            let dateMatch = text.match(/Date\s*\(Time\)\s*:\s*(\d{2}\/\d{2}\/\d{4})/i);
            if (dateMatch) {
                let parts = dateMatch[1].split("/");
                if (parts.length === 3) {
                    globalDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
            }
            const searchStr = "for life insurance";
            const textLower = text.toLowerCase();
            const idx = textLower.indexOf(searchStr);
            if (idx !== -1) {
                const substring = text.substring(idx);
                const match = substring.match(/of India,?\s+([\s\S]+)/i);
                if (match) {
                    const remainingParts = match[1].split(/\s{2,}|\t|\n/).map(s => s.trim()).filter(s => s !== "");
                    if (remainingParts.length > 0) {
                        cashierNameGlobal = remainingParts[0];
                    }
                    if (remainingParts.length > 1 && !remainingParts[1].startsWith("*SGST") && !remainingParts[1].startsWith("GST")) {
                        cashierIdGlobal = remainingParts[1];
                    }
                }
            }

            let receivedAmt = 0;
            let receivedAmtMatch = text.match(/Received\s+with\s+thanks\s+Rs\.?\s*([\d,]+(?:\.\d+)?)/i);
            if (receivedAmtMatch) {
                receivedAmt = parseFloat(receivedAmtMatch[1].replace(/,/g, ""));
            }

            let i = 0;

            while (i < lines.length) {
                // Find the start of a policy block - look for "Policy No" header
                if (lines[i] === "Policy No" || lines[i].startsWith("Policy No")) {
                    // Skip all header lines until we hit a line that looks like a policy number
                    let headerStart = i;
                    i++;

                    // Skip header lines: Name, Revival, (Yes/No), Plan, Term, DOC, etc.
                    while (i < lines.length && !/^\d{6,}$/.test(lines[i].replace(/\s/g, ""))) {
                        i++;
                    }

                    if (i >= lines.length) break;

                    // Now we're at the data values
                    const policyNo = lines[i]?.replace(/\s/g, "") || "";
                    const name = lines[i + 1] || "";
                    const revival = lines[i + 2] || "";
                    const plan = lines[i + 3] || "";
                    const term = lines[i + 4] || "";
                    const doc = lines[i + 5] || "";
                    const instPrem = lines[i + 6] || "0";
                    const mode = lines[i + 7] || "";
                    const sumAssured = lines[i + 8] || "0";

                    // Move past the first value block
                    i = i + 9;

                    // Skip the second header block: Total Premium, Late Fee, CD Chgs, etc.
                    // Look for "Grand Total" marker or numeric values after headers
                    let noOfInst = "0";
                    let dueFr = "";
                    let dueTo = "";
                    let totalPremium = "0";
                    let lateFee = "0";
                    let cdChgs = "0";
                    let cgst = "0";
                    let sgst = "0";
                    let totalAmt = "0";
                    let branchAgency = "";
                    let nextDue = "";

                    // Skip header lines until we find numeric/date values
                    while (i < lines.length) {
                        const line = lines[i];
                        // Check if this is a value line (starts with digit or is a date pattern)
                        if (/^\d/.test(line) && !line.startsWith("Total") && !line.startsWith("Grand") && !line.startsWith("No of") && !line.startsWith("Next")) {
                            break;
                        }
                        i++;
                    }

                    // Read: No of Inst, Due Fr, Due To
                    if (i < lines.length) noOfInst = lines[i] || "0";
                    if (i + 1 < lines.length) dueFr = lines[i + 1] || "";
                    if (i + 2 < lines.length) dueTo = lines[i + 2] || "";
                    i = i + 3;

                    // Skip "Grand Total (Rs)" line
                    while (i < lines.length) {
                        if (lines[i].includes("Grand Total")) {
                            i++;
                            break;
                        }
                        i++;
                    }

                    // Read financial values: Total Premium, Late Fee, CD Chgs, CGST, SGST, Total Amt
                    if (i < lines.length) totalPremium = lines[i] || "0";
                    if (i + 1 < lines.length) lateFee = lines[i + 1] || "0";
                    if (i + 2 < lines.length) cdChgs = lines[i + 2] || "0";
                    if (i + 3 < lines.length) cgst = lines[i + 3] || "0";
                    if (i + 4 < lines.length) sgst = lines[i + 4] || "0";
                    if (i + 5 < lines.length) totalAmt = lines[i + 5] || "0";
                    if (i + 6 < lines.length) branchAgency = lines[i + 6] || "";
                    if (i + 7 < lines.length) nextDue = lines[i + 7] || "";
                    i = i + 8;

                    // Parse DOC date to FUP format
                    let fup = "";
                    if (doc) {
                        try {
                            let parts = doc.split("/");
                            if (parts.length === 3) {
                                fup = moment(doc, "DD/MM/YYYY").format("YYYY-MM-DD");
                                if (fup === "Invalid date") fup = doc;
                            }
                        } catch (e) {
                            fup = doc;
                        }
                    }

                    // Extract branch code from "19G | 0099719G" format
                    let serviceBranch = branchAgency;
                    let agencyCode = "";
                    if (branchAgency.includes("|")) {
                        let parts = branchAgency.split("|");
                        serviceBranch = parts[0].trim();
                        agencyCode = parts[1] ? parts[1].trim() : "";
                    }

                    // Clean amount strings - remove commas
                    const cleanAmt = (val) => (val || "0").replace(/,/g, "").trim();
                    const gstTotal = (
                        parseFloat(cleanAmt(cgst) || 0) + parseFloat(cleanAmt(sgst) || 0)
                    ).toFixed(2);

                    let nextDueDate = null;
                    if (nextDue) {
                        try {
                            let parts = nextDue.split("/");
                            if (parts.length === 2) {
                                let yy = parts[1].length === 2 ? `20${parts[1]}` : parts[1];
                                let day = fup && fup.includes("-") ? fup.split("-")[2] : "01";
                                nextDueDate = moment(`${yy}-${parts[0]}-${day}`).format("YYYY-MM-DD");
                            } else {
                                nextDueDate = nextDue;
                            }
                        } catch (e) {
                            nextDueDate = nextDue;
                        }
                    }

                    records.push({
                        Date: globalDate,
                        NextDue: nextDueDate,
                        ReceiptNo: receiptNo,
                        CashierName: cashierNameGlobal,
                        CashierId: cashierIdGlobal,
                        PolicyNo: policyNo,
                        Name: name,
                        Revival: revival,
                        Plan: plan,
                        Term: term,
                        Mode: mode,
                        SumAssured: cleanAmt(sumAssured),
                        AgencyCode: agencyCode,
                        FUP: fup,
                        ServiceBranch: serviceBranch,
                        PremiumAmount: cleanAmt(instPrem),
                        Inst: noOfInst,
                        DueFr: dueFr,
                        DueTo: dueTo,
                        CDACharges: cleanAmt(cdChgs),
                        XCharges: "0",
                        CessAmt: "0",
                        LateFee: cleanAmt(lateFee),
                        LateFeeDiscount: "0",
                        GSTAmt: gstTotal,
                        TotAmtDR: cleanAmt(totalAmt),
                        Cash: receivedAmt,
                        Bank: 0,
                        Balance: (parseFloat(cleanAmt(totalAmt) || 0) - receivedAmt).toFixed(2),
                        UniqueID: uuidv4(),
                        ID: records.length + 1,
                    });
                } else {
                    i++;
                }
            }

            return records;
        } catch (error) {
            console.error("PDF text parse error:", error);
            toaster.push(
                <Message type="error" bordered showIcon>
                    <strong>Error</strong> {`Error parsing PDF copied text`}
                </Message>
            );
            return [];
        }
    };

    const handlePdfSelect = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        // Reset file input so the same file can be selected again
        event.target.value = "";

        if (file.type !== "application/pdf") {
            toaster.push(
                <Message type="error" bordered showIcon>
                    <strong>Error!</strong> Please select a valid PDF file
                </Message>
            );
            return;
        }

        setPdfLoading(true);
        setPdfProgress("Reading PDF...");

        try {
            const allText = await pdfToText(file);
            console.log("=== EXTRACTED PDF TEXT ===", allText);
            setPdfProgress("Parsing extracted text...");

            // Parse the text - try to extract tabular data
            let parsedData = parsePdfCopiedData(allText);

            if (!parsedData || parsedData.length === 0) {
                parsedData = parsePdfText(allText);
            }

            if (parsedData && parsedData.length > 0) {
                setData(parsedData);
                toaster.push(
                    <Message type="success" bordered showIcon>
                        <strong>Success!</strong>{" "}
                        {`Extracted ${parsedData.length} records from PDF`}
                    </Message>
                );
            } else {
                toaster.push(
                    <Message type="warning" bordered showIcon>
                        <strong>Warning!</strong>{" "}
                        No structured data could be extracted from the PDF. Raw text has been logged to console.
                    </Message>
                );
                console.log("Raw PDF Text:", allText);
            }
        } catch (error) {
            console.error("PDF Extraction Error:", error);
            toaster.push(
                <Message type="error" bordered showIcon>
                    <strong>Error!</strong>{" "}
                    {`Failed to read PDF: ${error.message || error}`}
                </Message>
            );
        } finally {
            setPdfLoading(false);
            setPdfProgress("");
        }
    };

    const parsePdfText = (text) => {
        try {
            let receiptNo = "";
            let receiptNoMatch = text.match(/Receipt\s+Number\s*[:\-]?\s*(\S+)/i);
            if (receiptNoMatch) {
                receiptNo = receiptNoMatch[1].trim();
            }

            let cashierNameGlobal = "DIFS";
            let cashierIdGlobal = "";
            let globalDate = moment().format("YYYY-MM-DD");
            let dateMatch = text.match(/Date\s*\(Time\)\s*:\s*(\d{2}\/\d{2}\/\d{4})/i);
            if (dateMatch) {
                let parts = dateMatch[1].split("/");
                if (parts.length === 3) {
                    globalDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
                }
            }
            const searchStr = "for life insurance";
            const textLower = text.toLowerCase();
            const idx = textLower.indexOf(searchStr);
            if (idx !== -1) {
                const substring = text.substring(idx);
                const match = substring.match(/of India,?\s+([\s\S]+)/i);
                if (match) {
                    const remainingParts = match[1].split(/\s{2,}|\t|\n/).map(s => s.trim()).filter(s => s !== "");
                    if (remainingParts.length > 0) {
                        cashierNameGlobal = remainingParts[0];
                    }
                    if (remainingParts.length > 1 && !remainingParts[1].startsWith("*SGST") && !remainingParts[1].startsWith("GST")) {
                        cashierIdGlobal = remainingParts[1];
                    }
                }
            }

            let receivedAmt = 0;
            let receivedAmtMatch = text.match(/Received\s+with\s+thanks\s+Rs\.?\s*([\d,]+(?:\.\d+)?)/i);
            if (receivedAmtMatch) {
                receivedAmt = parseFloat(receivedAmtMatch[1].replace(/,/g, ""));
            }

            const columns = text.split(/\s{2,}|\t|\n/).map(c => c.trim()).filter(c => c !== "");
            const dataRows = [];

            // Extract global footer fields
            let fullName = "";
            let fatherName = "";
            let vpo = "";
            let tehsil = "";
            let district = "";
            let pinCode = "";
            let mobile = "";

            // Find "S/O" or similar to locate the address block
            const soIndex = columns.findIndex(c => /^S\/O|^D\/O|^W\/O|^C\/O/i.test(c));
            if (soIndex !== -1) {
                fatherName = columns[soIndex];
                fullName = columns[soIndex - 1] || "";

                let rawVpo = columns[soIndex + 1] || "";
                let rawTehsil = columns[soIndex + 2] || "";
                pinCode = columns[soIndex + 3] || "";

                // Clean VPO (e.g. "Vpo-Girwarsar" -> "Girwarsar")
                let vpoMatch = rawVpo.match(/vpo[-\s]+([^,]+)/i);
                if (vpoMatch) {
                    vpo = vpoMatch[1].trim();
                    // if it contains 'Via', remove it and everything after
                    let viaIdx = vpo.toLowerCase().indexOf('via');
                    if (viaIdx !== -1) {
                        vpo = vpo.substring(0, viaIdx).replace(/-$/, "").trim();
                    }
                } else {
                    vpo = rawVpo;
                }

                // Extract Tehsil and District (e.g. "Teh-Sujangarh Dt-Churu Ra" or "Teh-Bidasar, Churu")
                let tehsilRaw = rawTehsil;

                let dtMatch = rawTehsil.match(/Dt[-\s]+([^,\s]+)/i);
                if (dtMatch) {
                    district = dtMatch[1].trim();
                    tehsilRaw = rawTehsil.substring(0, dtMatch.index).trim();
                } else {
                    let commaIdx = rawTehsil.indexOf(",");
                    if (commaIdx !== -1) {
                        district = rawTehsil.substring(commaIdx + 1).trim();
                        tehsilRaw = rawTehsil.substring(0, commaIdx).trim();
                    }
                }

                let tehMatch = tehsilRaw.match(/Teh[-\s]+(.+)/i);
                if (tehMatch) {
                    tehsil = tehMatch[1].trim();
                } else {
                    tehsil = tehsilRaw.replace(/^Teh[-\s]+/i, "").trim();
                }

                // Final cleanups to remove any trailing commas
                vpo = vpo.replace(/,+$/, "").trim();
                tehsil = tehsil.replace(/,+$/, "").trim();
                district = district.replace(/,+$/, "").trim();
            }

            // Find Mobile
            const mobileCol = columns.find(c => /^mobile/i.test(c));
            if (mobileCol) {
                let rawMobile = mobileCol.replace(/^mobile\s*[:\-]?\s*/i, "").trim();
                let digits = rawMobile.replace(/\D/g, "");
                if (digits.length >= 10) {
                    mobile = digits.slice(-10);
                } else {
                    mobile = rawMobile;
                }
            }

            // Find all policies (policy numbers are 9 digits)
            for (let i = 0; i < columns.length; i++) {
                if (/^\d{9}$/.test(columns[i])) {
                    const policyIdx = i;

                    let doc = columns[policyIdx + 5] || "";
                    let fup = "";
                    if (doc) {
                        try {
                            let parts = doc.split("/");
                            if (parts.length === 3) {
                                fup = moment(doc, "DD/MM/YYYY").format("YYYY-MM-DD");
                                if (fup === "Invalid date") fup = doc;
                            }
                        } catch (e) {
                            fup = doc;
                        }
                    }

                    let branchAgency = columns[policyIdx + 18] || "";
                    let serviceBranch = branchAgency;
                    let agencyCode = "";
                    if (branchAgency.includes("|")) {
                        let parts = branchAgency.split("|");
                        serviceBranch = parts[0].trim();
                        agencyCode = parts[1] ? parts[1].trim() : "";
                    }

                    const cleanAmt = (val) => {
                        if (!val) return "0";
                        let cleaned = val.replace(/,/g, "").trim();
                        if (cleaned.startsWith(".")) cleaned = "0" + cleaned;
                        return cleaned;
                    };

                    const cgst = cleanAmt(columns[policyIdx + 15]);
                    const sgst = cleanAmt(columns[policyIdx + 16]);
                    const gstTotal = (parseFloat(cgst || 0) + parseFloat(sgst || 0)).toFixed(2);

                    const totalAmt = cleanAmt(columns[policyIdx + 17]);

                    let nextDueStr = columns[policyIdx + 19] || "";
                    let nextDueDate = null;
                    if (nextDueStr) {
                        try {
                            let parts = nextDueStr.split("/");
                            if (parts.length === 2) {
                                let yy = parts[1].length === 2 ? `20${parts[1]}` : parts[1];
                                let day = fup && fup.includes("-") ? fup.split("-")[2] : "01";
                                nextDueDate = moment(`${yy}-${parts[0]}-${day}`).format("YYYY-MM-DD");
                            } else {
                                nextDueDate = nextDueStr;
                            }
                        } catch (e) {
                            nextDueDate = nextDueStr;
                        }
                    }

                    dataRows.push({
                        Date: globalDate,
                        NextDue: nextDueDate,
                        ReceiptNo: receiptNo,
                        CashierName: cashierIdGlobal + " - " + cashierNameGlobal,
                        CashierId: null,
                        PolicyNo: columns[policyIdx],
                        Name: columns[policyIdx + 1] || "",
                        FullName: fullName,
                        FatherName: fatherName,
                        Vpo: vpo,
                        Tehsil: tehsil,
                        District: district,
                        PinCode: pinCode,
                        Mobile: mobile,
                        Revival: columns[policyIdx + 2] || "",
                        Plan: columns[policyIdx + 3] || "",
                        Term: columns[policyIdx + 4] || "",
                        Mode: columns[policyIdx + 7] || "",
                        SumAssured: cleanAmt(columns[policyIdx + 8]),
                        AgencyCode: agencyCode,
                        FUP: fup,
                        ServiceBranch: serviceBranch,
                        PremiumAmount: cleanAmt(columns[policyIdx + 6]),
                        Inst: cleanAmt(columns[policyIdx + 9]),
                        DueFr: columns[policyIdx + 10] || "",
                        DueTo: columns[policyIdx + 11] || "",
                        CDACharges: cleanAmt(columns[policyIdx + 14]),
                        XCharges: "0",
                        CessAmt: "0",
                        LateFee: cleanAmt(columns[policyIdx + 13]),
                        LateFeeDiscount: "0",
                        GSTAmt: gstTotal,
                        TotAmtDR: totalAmt,
                        Cash: receivedAmt,
                        Bank: 0,
                        Balance: (parseFloat(cleanAmt(totalAmt) || 0) - receivedAmt).toFixed(2),
                        UniqueID: uuidv4(),
                        ID: dataRows.length + 1,
                    });
                }
            }

            return dataRows;
        } catch (error) {
            console.error("Parse error:", error);
            toaster.push(
                <Message type="error" bordered showIcon>
                    <strong>Error</strong> {`Error parsing PDF text data`}
                </Message>
            );
            return [];
        }
    };

    function onGridReady() { }
    const history = useNavigate();
    const location = useLocation();
    const updateQueryParams = React.useCallback(
        (activeKey) => {
            const params = new URLSearchParams(location.search);
            params.set("data", JSON.stringify(activeKey));
            history(`?${params.toString()}`, { replace: true });
        },
        [history, location.search]
    );

    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        const nameFromParams = params.get("data");

        if (nameFromParams) {
            setData(JSON.parse(nameFromParams));
        }
    }, [location.search]);

    async function handleImport() {
        setStatus(true);
        if (data.length > 0) {
            const duplicates = findDuplicateIds(data);
            if (hasInvalidIds(data)) {
                console.log("Invalid IDs found:");
                toaster.push(
                    <Message type="error" bordered showIcon>
                        <strong>Invalid IDs!</strong> {`There are some invalid IDs`}
                    </Message>
                );
                setStatus(false);
                return;
            } else if (duplicates.length > 0) {
                console.log("Duplicate IDs found:");
                toaster.push(
                    <Message type="error" bordered showIcon>
                        <strong>Duplicate IDs!</strong>{" "}
                        {`Duplicate IDs found - ${duplicates.toString()}`}
                    </Message>
                );
                setStatus(false);
                return;
            } else {
                try {
                    axiosPrivate
                        .post("ImportPremiumPointNew.php", {
                            data,
                        })
                        .then((response) => {
                            const result = response.data;
                            if (result.status === 1) {
                                toaster.push(
                                    <Message type="success" bordered showIcon>
                                        <strong>Success!</strong> {result.Success}
                                    </Message>,
                                    { placement: "topEnd", duration: 1000 }
                                );
                                const newData = mergeArraysById(data, result.Data || []);
                                console.log(newData);
                                setData(newData);
                                updateQueryParams(newData);
                            } else {
                                toaster.push(
                                    <Message type="error" bordered showIcon>
                                        <strong>Error!</strong> {result.Success || result.Error}
                                        {result.Errors && result.Errors.length > 0 && (
                                            <ul style={{ marginTop: '10px', paddingLeft: '20px', marginBottom: 0 }}>
                                                {result.Errors.map((err, idx) => (
                                                    <li key={idx}>{err}</li>
                                                ))}
                                            </ul>
                                        )}
                                    </Message>,
                                    { placement: "topEnd", duration: 1000 }
                                );
                            }
                            setStatus(false);
                            // resetForm();
                        })
                        .catch((error) => {
                            console.error("Error submitting data:", error);
                            setStatus(false);
                        });
                } catch (error) {
                    console.error(error);
                    setStatus(false);
                }
            }
        } else {
            toaster.push(
                <Message type="error" bordered showIcon>
                    Please upload a file first
                </Message>
            );
            setStatus(false);
        }
    }

    return (
        <>
            <div
                style={{ width: "100%", border: "0.5px dashed #999", borderRadius: 10 }}
            >
                <Heading level={5} style={{ textAlign: "center" }}>
                    Import Premium Point
                </Heading>
            </div>
            <div
                style={{
                    width: "100%",
                    margin: "10px 0px 10px 0px",
                    padding: 5,
                    border: "0.5px dashed #999",
                    borderRadius: 10,
                }}
            >
                <Stack direction="row" spacing={4} alignItems="center">

                    <Button color="blue" appearance="primary" onClick={handlePastePdf}>
                        Paste from PDF
                    </Button>

                    <input
                        type="file"
                        accept=".pdf"
                        ref={pdfInputRef}
                        style={{ display: "none" }}
                        onChange={handlePdfSelect}
                    />
                    <LoadingButton
                        disabled={pdfLoading}
                        variant="contained"
                        color="primary"
                        startIcon={<PictureAsPdf />}
                        onClick={() => pdfInputRef.current?.click()}
                        loading={pdfLoading}
                        sx={{ my: 2 }}
                    >
                        {pdfLoading ? "Reading PDF..." : "Read PDF"}
                    </LoadingButton>

                    <LoadingButton
                        disabled={status}
                        type="submit"
                        color="secondary"
                        variant="contained"
                        onClick={handleImport}
                        loading={status}
                        sx={{ my: 2 }}
                    >
                        {status ? "Uploading..." : "Import"}
                    </LoadingButton>
                    <Button
                        onClick={() => {
                            setData([]);
                        }}
                    >
                        Clear
                    </Button>
                    {pdfProgress && (
                        <span style={{ fontSize: 13, color: "#1976d2", fontStyle: "italic" }}>
                            {pdfProgress}
                        </span>
                    )}
                </Stack>
            </div>
            <div
                style={{
                    width: "100%",
                    minHeight: 600,
                    border: "0.5px dotted #999",
                    marginTop: 5,
                    borderRadius: 10,
                }}
            >
                <Grid fluid style={{ padding: 10 }}>
                    <Row className="show-grid">
                        <Col xs={24} sm={24} md={24}>
                            <Row className="show-grid" style={{ maxHeight: 350 }}>
                                <AgGrid
                                    onRowSelectedData={setSelectedRowData}
                                    handleViewModalOpen={handleOpen}
                                    settingsName="PastePremiumPointNew"
                                    headerComponent={() => <p></p>}
                                    setFilteredRows={setFilteredRows}
                                    Source="PastePremiumPointNew"
                                    exportAllowed={true}
                                    columns={columns1}
                                    rowData={data}
                                    onGridReady={onGridReady}
                                    defaultColumn={["UniqueID"]}
                                    showHeaderItems={false}
                                    passdata={true}
                                />
                            </Row>
                        </Col>
                    </Row>
                </Grid>
            </div>
            <SideDrawer
                open={open}
                onClose={handleClose}
                title="Update Premium Point"
            >
                <Formik
                    validationSchema={validationSchema}
                    initialValues={initialValues}
                    enableReinitialize={true}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false);
                        const totAmtDR = parseFloat(String(values.TotAmtDR).replace(/,/g, "") || 0);
                        const cash = parseFloat(String(values.Cash).replace(/,/g, "") || 0);
                        const bank = parseFloat(String(values.Bank).replace(/,/g, "") || 0);
                        const balance = totAmtDR - cash - bank;
                        const newData = {
                            ...values,
                            CashierId: values.CashierId?.value || values.CashierId,
                            CashierName: values.CashierName,
                            PaymentBy: values.PaymentBy.value,
                            FUP: moment(values.FUP).format("YYYY-MM-DD"),
                            Date: moment(values.Date).format("YYYY-MM-DD"),
                            NextDue: values.NextDue ? moment(values.NextDue).format("YYYY-MM-DD") : null,
                            TotAmtDR: totAmtDR,
                            Cash: cash,
                            Bank: bank,
                            Balance: balance,
                        };
                        console.log(newData);
                        updateDatainGrid(newData, values.UniqueID);
                    }}
                >
                    {({
                        values,
                        errors,
                        setFieldValue,
                        handleSubmit,
                        isValidating,
                        isSubmitting,
                        touched,
                        handleBlur,
                        handleChange,
                    }) => {
                        // console.log(errors);
                        // console.log(values);
                        return (
                            <form>
                                <div>
                                    <div className="row">
                                        <Grid fluid style={{ padding: 4 }}>
                                            <Row className="show-grid">
                                                <Col xs={24} sm={24} md={24}>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            display: "flex",
                                                            alignItems: "flex-end",
                                                        }}
                                                    >
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DateField
                                                                label="Date"
                                                                variant="standard"
                                                                size="small"
                                                                name="Date"
                                                                format="dd-MM-yyyy"
                                                                value={values.Date}
                                                                onChange={(value) =>
                                                                    setFieldValue("Date", value, true)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={touched.Date && Boolean(errors.Date)}
                                                                helperText={touched.Date && errors.Date}
                                                            />
                                                        </LocalizationProvider>
                                                    </Row>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            display: "flex",
                                                            alignItems: "flex-end",
                                                        }}
                                                    >
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DateField
                                                                label="Next Due"
                                                                variant="standard"
                                                                size="small"
                                                                name="NextDue"
                                                                format="dd-MM-yyyy"
                                                                value={values.NextDue}
                                                                onChange={(value) =>
                                                                    setFieldValue("NextDue", value, true)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={touched.NextDue && Boolean(errors.NextDue)}
                                                                helperText={touched.NextDue && errors.NextDue}
                                                            />
                                                        </LocalizationProvider>
                                                    </Row>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            marginLeft: -10,
                                                        }}
                                                    >
                                                        <Autocomplete
                                                            key="ID"
                                                            name={`CashierId`}
                                                            options={
                                                                CashierList.error ? [null] : CashierList.data
                                                            }
                                                            getOptionLabel={(option) => option?.title || ""}
                                                            disableClearable={true}
                                                            value={
                                                                Boolean(values.CashierId)
                                                                    ? values.CashierId
                                                                    : { value: "", title: "" }
                                                            }
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.CashierId &&
                                                                Boolean(errors.CashierId)
                                                            }
                                                            helperText={
                                                                touched.CashierId && errors.CashierId
                                                            }
                                                            onChange={(_, newValue) => {
                                                                setFieldValue(`CashierId`, newValue, true);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    name="CashierId"
                                                                    onBlur={handleBlur}
                                                                    error={
                                                                        touched.CashierId &&
                                                                        Boolean(errors.CashierId)
                                                                    }
                                                                    helperText={
                                                                        touched.CashierId && errors.CashierId
                                                                    }
                                                                    label="Cashier Id"
                                                                    variant="standard"
                                                                />
                                                            )}
                                                            style={{ width: 200 }}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            fullWidth
                                                            name={`CashierName`}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.CashierName),
                                                            }}
                                                            label="Cashier Name"
                                                            size="small"
                                                            as={TextField}
                                                            placeholder="Enter Cashier Name"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.CashierName && Boolean(errors.CashierName)
                                                            }
                                                            helperText={touched.CashierName && errors.CashierName}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            fullWidth
                                                            name={`ReceiptNo`}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.ReceiptNo),
                                                            }}
                                                            label="Receipt No"
                                                            size="small"
                                                            as={TextField}
                                                            placeholder="Enter Receipt No"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.ReceiptNo && Boolean(errors.ReceiptNo)
                                                            }
                                                            helperText={touched.ReceiptNo && errors.ReceiptNo}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            fullWidth
                                                            name={`PolicyNo`}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.PolicyNo),
                                                            }}
                                                            label="Policy No"
                                                            size="small"
                                                            as={TextField}
                                                            placeholder="Enter Policy No"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.PolicyNo && Boolean(errors.PolicyNo)
                                                            }
                                                            helperText={touched.PolicyNo && errors.PolicyNo}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            fullWidth
                                                            name={`Name`}
                                                            variant="standard"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.Name),
                                                            }}
                                                            label="Name"
                                                            size="small"
                                                            as={TextField}
                                                            placeholder="Enter Name"
                                                            onBlur={handleBlur}
                                                            error={touched.Name && Boolean(errors.Name)}
                                                            helperText={touched.Name && errors.Name}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`FullName`} variant="standard" InputLabelProps={{ shrink: Boolean(values.FullName) }} label="Full Name" size="small" as={TextField} placeholder="Enter Full Name" onBlur={handleBlur} error={touched.FullName && Boolean(errors.FullName)} helperText={touched.FullName && errors.FullName} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`FatherName`} variant="standard" InputLabelProps={{ shrink: Boolean(values.FatherName) }} label="Father Name" size="small" as={TextField} placeholder="Enter Father Name" onBlur={handleBlur} error={touched.FatherName && Boolean(errors.FatherName)} helperText={touched.FatherName && errors.FatherName} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`Vpo`} variant="standard" InputLabelProps={{ shrink: Boolean(values.Vpo) }} label="VPO" size="small" as={TextField} placeholder="Enter VPO" onBlur={handleBlur} error={touched.Vpo && Boolean(errors.Vpo)} helperText={touched.Vpo && errors.Vpo} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`Tehsil`} variant="standard" InputLabelProps={{ shrink: Boolean(values.Tehsil) }} label="Tehsil" size="small" as={TextField} placeholder="Enter Tehsil" onBlur={handleBlur} error={touched.Tehsil && Boolean(errors.Tehsil)} helperText={touched.Tehsil && errors.Tehsil} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`District`} variant="standard" InputLabelProps={{ shrink: Boolean(values.District) }} label="District" size="small" as={TextField} placeholder="Enter District" onBlur={handleBlur} error={touched.District && Boolean(errors.District)} helperText={touched.District && errors.District} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`PinCode`} variant="standard" InputLabelProps={{ shrink: Boolean(values.PinCode) }} label="Pin Code" size="small" as={TextField} placeholder="Enter Pin Code" onBlur={handleBlur} error={touched.PinCode && Boolean(errors.PinCode)} helperText={touched.PinCode && errors.PinCode} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`Mobile`} variant="standard" InputLabelProps={{ shrink: Boolean(values.Mobile) }} label="Mobile" size="small" as={TextField} placeholder="Enter Mobile" onBlur={handleBlur} error={touched.Mobile && Boolean(errors.Mobile)} helperText={touched.Mobile && errors.Mobile} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`Revival`} variant="standard" InputLabelProps={{ shrink: Boolean(values.Revival) }} label="Revival" size="small" as={TextField} placeholder="Enter Revival" onBlur={handleBlur} error={touched.Revival && Boolean(errors.Revival)} helperText={touched.Revival && errors.Revival} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`Plan`} variant="standard" InputLabelProps={{ shrink: Boolean(values.Plan) }} label="Plan" size="small" as={TextField} placeholder="Enter Plan" onBlur={handleBlur} error={touched.Plan && Boolean(errors.Plan)} helperText={touched.Plan && errors.Plan} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`Term`} variant="standard" InputLabelProps={{ shrink: Boolean(values.Term) }} label="Term" size="small" as={TextField} placeholder="Enter Term" onBlur={handleBlur} error={touched.Term && Boolean(errors.Term)} helperText={touched.Term && errors.Term} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`Mode`} variant="standard" InputLabelProps={{ shrink: Boolean(values.Mode) }} label="Mode" size="small" as={TextField} placeholder="Enter Mode" onBlur={handleBlur} error={touched.Mode && Boolean(errors.Mode)} helperText={touched.Mode && errors.Mode} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`SumAssured`} variant="standard" InputLabelProps={{ shrink: Boolean(values.SumAssured) }} label="Sum Assured" size="small" as={TextField} placeholder="Enter Sum Assured" onBlur={handleBlur} error={touched.SumAssured && Boolean(errors.SumAssured)} helperText={touched.SumAssured && errors.SumAssured} />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field fullWidth name={`AgencyCode`} variant="standard" InputLabelProps={{ shrink: Boolean(values.AgencyCode) }} label="Agency Code" size="small" as={TextField} placeholder="Enter Agency Code" onBlur={handleBlur} error={touched.AgencyCode && Boolean(errors.AgencyCode)} helperText={touched.AgencyCode && errors.AgencyCode} />
                                                    </Row>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            display: "flex",
                                                            alignItems: "flex-end",
                                                        }}
                                                    >
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DateField
                                                                label="DOC"
                                                                variant="standard"
                                                                size="small"
                                                                name="FUP"
                                                                format="dd-MM-yyyy"
                                                                value={values.FUP}
                                                                onChange={(value) =>
                                                                    setFieldValue("FUP", value, true)
                                                                }
                                                                onBlur={handleBlur}
                                                                error={touched.FUP && Boolean(errors.FUP)}
                                                                helperText={touched.FUP && errors.FUP}
                                                            />
                                                        </LocalizationProvider>
                                                    </Row>

                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`ServiceBranch`}
                                                            fullWidth
                                                            label="ServiceBranch"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.ServiceBranch),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Service Branch"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.ServiceBranch &&
                                                                Boolean(errors.ServiceBranch)
                                                            }
                                                            helperText={
                                                                touched.ServiceBranch && errors.ServiceBranch
                                                            }
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`PremiumAmount`}
                                                            fullWidth
                                                            label="Premium Amount"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.PremiumAmount),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Premium Amount"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.PremiumAmount &&
                                                                Boolean(errors.PremiumAmount)
                                                            }
                                                            helperText={
                                                                touched.PremiumAmount && errors.PremiumAmount
                                                            }
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`Inst`}
                                                            fullWidth
                                                            label="Inst"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.Inst),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Inst"
                                                            onBlur={handleBlur}
                                                            error={touched.Inst && Boolean(errors.Inst)}
                                                            helperText={touched.Inst && errors.Inst}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`DueFr`}
                                                            fullWidth
                                                            label="Due Fr"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.DueFr),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Due Fr"
                                                            onBlur={handleBlur}
                                                            error={touched.DueFr && Boolean(errors.DueFr)}
                                                            helperText={touched.DueFr && errors.DueFr}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`DueTo`}
                                                            fullWidth
                                                            label="Due To"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.DueTo),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Due To"
                                                            onBlur={handleBlur}
                                                            error={touched.DueTo && Boolean(errors.DueTo)}
                                                            helperText={touched.DueTo && errors.DueTo}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`CDACharges`}
                                                            fullWidth
                                                            label="CDACharges"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.CDACharges),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter CDACharges"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.CDACharges && Boolean(errors.CDACharges)
                                                            }
                                                            helperText={
                                                                touched.CDACharges && errors.CDACharges
                                                            }
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`XCharges`}
                                                            fullWidth
                                                            label="XCharges"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.XCharges),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter XCharges"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.XCharges && Boolean(errors.XCharges)
                                                            }
                                                            helperText={touched.XCharges && errors.XCharges}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`CessAmt`}
                                                            fullWidth
                                                            label="CessAmt"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.CessAmt),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter CessAmt"
                                                            onBlur={handleBlur}
                                                            error={touched.CessAmt && Boolean(errors.CessAmt)}
                                                            helperText={touched.CessAmt && errors.CessAmt}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`LateFee`}
                                                            fullWidth
                                                            label="LateFee"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.LateFee),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Late Fee"
                                                            onBlur={handleBlur}
                                                            error={touched.LateFee && Boolean(errors.LateFee)}
                                                            helperText={touched.LateFee && errors.LateFee}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`LateFeeDiscount`}
                                                            fullWidth
                                                            label="Late Fee Discount"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.LateFeeDiscount),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Late Fee Discount"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.LateFeeDiscount &&
                                                                Boolean(errors.LateFeeDiscount)
                                                            }
                                                            helperText={
                                                                touched.LateFeeDiscount &&
                                                                errors.LateFeeDiscount
                                                            }
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`GSTAmt`}
                                                            fullWidth
                                                            label="GSTAmt"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.GSTAmt),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter GST Amt"
                                                            onBlur={handleBlur}
                                                            error={touched.GSTAmt && Boolean(errors.GSTAmt)}
                                                            helperText={touched.GSTAmt && errors.GSTAmt}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`TotAmtDR`}
                                                            fullWidth
                                                            label="Total Amt DR"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.TotAmtDR),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            onChange={(E) => {
                                                                handleChange(E);
                                                                let Amnt = E.target.value;
                                                                let Balance =
                                                                    parseFloat(Amnt) -
                                                                    parseFloat(values.Cash || 0) -
                                                                    parseFloat(values.Bank || 0);
                                                                setFieldValue("Balance", Balance);
                                                            }}
                                                            placeholder="Enter Total Amt DR"
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.TotAmtDR && Boolean(errors.TotAmtDR)
                                                            }
                                                            helperText={touched.TotAmtDR && errors.TotAmtDR}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`Cash`}
                                                            fullWidth
                                                            label="Cash"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.Cash),
                                                            }}
                                                            onChange={(E) => {
                                                                handleChange(E);
                                                                let Amnt = E.target.value;
                                                                let Balance =
                                                                    parseFloat(values.TotAmtDR) -
                                                                    parseFloat(Amnt || 0) -
                                                                    parseFloat(values.Bank || 0);
                                                                setFieldValue("Balance", Balance);
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Cash"
                                                            onBlur={handleBlur}
                                                            error={touched.Cash && Boolean(errors.Cash)}
                                                            helperText={touched.Cash && errors.Cash}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`Bank`}
                                                            fullWidth
                                                            label="Bank"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.Bank),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            onChange={(E) => {
                                                                handleChange(E);
                                                                let Amnt = E.target.value;
                                                                let Balance =
                                                                    parseFloat(values.TotAmtDR) -
                                                                    parseFloat(values.Cash || 0) -
                                                                    parseFloat(Amnt);
                                                                setFieldValue("Balance", Balance);
                                                            }}
                                                            placeholder="Enter Bank"
                                                            onBlur={handleBlur}
                                                            error={touched.Bank && Boolean(errors.Bank)}
                                                            helperText={touched.Bank && errors.Bank}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`Balance`}
                                                            fullWidth
                                                            label="Total Balance"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.Balance),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Balance"
                                                            onBlur={handleBlur}
                                                            error={touched.Balance && Boolean(errors.Balance)}
                                                            helperText={touched.Balance && errors.Balance}
                                                        />
                                                    </Row>
                                                    <Row
                                                        gutter={0}
                                                        style={{
                                                            marginBottom: 10,
                                                            marginLeft: -10,
                                                        }}
                                                    >
                                                        <Autocomplete
                                                            key="ID"
                                                            name={`PaymentBy`}
                                                            options={
                                                                PaymentByList.error
                                                                    ? [null]
                                                                    : PaymentByList.data
                                                            }
                                                            getOptionLabel={(option) => option?.title}
                                                            disableClearable={true}
                                                            value={
                                                                Boolean(values.PaymentBy)
                                                                    ? values.PaymentBy
                                                                    : { value: "", title: "" }
                                                            }
                                                            onBlur={handleBlur}
                                                            error={
                                                                touched.PaymentBy && Boolean(errors.PaymentBy)
                                                            }
                                                            helperText={touched.PaymentBy && errors.PaymentBy}
                                                            onChange={(_, newValue) => {
                                                                console.log(values);
                                                                console.log(errors);
                                                                setFieldValue(`PaymentBy`, newValue, true);
                                                            }}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    name="PaymentBy"
                                                                    onBlur={handleBlur}
                                                                    error={
                                                                        touched.PaymentBy &&
                                                                        Boolean(errors.PaymentBy)
                                                                    }
                                                                    helperText={
                                                                        touched.PaymentBy && errors.PaymentBy
                                                                    }
                                                                    label="Payment By"
                                                                    variant="standard"
                                                                />
                                                            )}
                                                            style={{ width: 200 }}
                                                        />
                                                    </Row>
                                                    <Row gutter={0} style={{ marginBottom: 10 }}>
                                                        <Field
                                                            name={`Remark`}
                                                            fullWidth
                                                            label="Remark"
                                                            size="small"
                                                            InputLabelProps={{
                                                                shrink: Boolean(values.Remark),
                                                            }}
                                                            variant="standard"
                                                            as={TextField}
                                                            placeholder="Enter Remark"
                                                            onBlur={handleBlur}
                                                            error={touched.Remark && Boolean(errors.Remark)}
                                                            helperText={touched.Remark && errors.Remark}
                                                        />
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                    <Divider />
                                    &nbsp; &nbsp;
                                    <>
                                        <LoadingButton
                                            disabled={isSubmitting}
                                            type="submit"
                                            color="secondary"
                                            variant="contained"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                handleSubmit(e);
                                            }}
                                            loading={isValidating}
                                            sx={{ my: 2 }}
                                        >
                                            {isSubmitting ? "Submitting..." : "Submit"}
                                        </LoadingButton>
                                        &nbsp; &nbsp;
                                        <Button color="red" appearance="primary" sx={{ my: 2 }}>
                                            {"Delete"}
                                        </Button>
                                    </>
                                </div>
                            </form>
                        );
                    }}
                </Formik>
            </SideDrawer>
        </>
    );
}
